"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveValue = void 0;
var engine_types_1 = require("@verified/c11-engine.types");
var getValue_1 = require("./getValue");
var get_1 = __importDefault(require("lodash/get"));
var resolveValue = function (structure, value, invokable) {
    if (value.type === engine_types_1.ValueTypes.CONST) {
        return value.value;
    }
    else if (value.type === engine_types_1.ValueTypes.EXTERNAL) {
        return (0, getValue_1.getValue)("external", structure, value.path);
    }
    else if (value.type === engine_types_1.ValueTypes.INTERNAL) {
        return (0, getValue_1.getValue)("internal", structure, value.path);
    }
    else if (value.type === engine_types_1.ValueTypes.INVOKE) {
        if (invokable) {
            return (0, get_1.default)(invokable, value.path, undefined);
        }
    }
};
exports.resolveValue = resolveValue;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzb2x2ZVZhbHVlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2dyYXBoL3Jlc29sdmVWYWx1ZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxrREFBK0U7QUFDL0UsdUNBQXNDO0FBQ3RDLG1EQUE2QjtBQUV0QixJQUFNLFlBQVksR0FBRyxVQUMxQixTQUF5QixFQUN6QixLQUFxQixFQUNyQixTQUFlO0lBRWYsSUFBSSxLQUFLLENBQUMsSUFBSSxLQUFLLHlCQUFVLENBQUMsS0FBSyxFQUFFO1FBQ25DLE9BQU8sS0FBSyxDQUFDLEtBQUssQ0FBQztLQUNwQjtTQUFNLElBQUksS0FBSyxDQUFDLElBQUksS0FBSyx5QkFBVSxDQUFDLFFBQVEsRUFBRTtRQUM3QyxPQUFPLElBQUEsbUJBQVEsRUFBQyxVQUFVLEVBQUUsU0FBUyxFQUFFLEtBQUssQ0FBQyxJQUFJLENBQUMsQ0FBQztLQUNwRDtTQUFNLElBQUksS0FBSyxDQUFDLElBQUksS0FBSyx5QkFBVSxDQUFDLFFBQVEsRUFBRTtRQUM3QyxPQUFPLElBQUEsbUJBQVEsRUFBQyxVQUFVLEVBQUUsU0FBUyxFQUFFLEtBQUssQ0FBQyxJQUFJLENBQUMsQ0FBQztLQUNwRDtTQUFNLElBQUksS0FBSyxDQUFDLElBQUksS0FBSyx5QkFBVSxDQUFDLE1BQU0sRUFBRTtRQUMzQyxJQUFJLFNBQVMsRUFBRTtZQUNiLE9BQU8sSUFBQSxhQUFHLEVBQUMsU0FBUyxFQUFFLEtBQUssQ0FBQyxJQUFJLEVBQUUsU0FBUyxDQUFDLENBQUM7U0FDOUM7S0FDRjtBQUNILENBQUMsQ0FBQztBQWhCVyxRQUFBLFlBQVksZ0JBZ0J2QiJ9